"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DeleteBucketMetricsConfigurationInput_1 = require("./DeleteBucketMetricsConfigurationInput");
var DeleteBucketMetricsConfigurationOutput_1 = require("./DeleteBucketMetricsConfigurationOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.DeleteBucketMetricsConfiguration = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "DeleteBucketMetricsConfiguration",
    http: {
        method: "DELETE",
        requestUri: "/{Bucket}?metrics"
    },
    input: {
        shape: DeleteBucketMetricsConfigurationInput_1.DeleteBucketMetricsConfigurationInput
    },
    output: {
        shape: DeleteBucketMetricsConfigurationOutput_1.DeleteBucketMetricsConfigurationOutput
    },
    errors: []
};
//# sourceMappingURL=DeleteBucketMetricsConfiguration.js.map